import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default function AvisoLegal() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-3xl mx-auto prose prose-slate">
          <h1 className="font-heading font-bold text-3xl text-municipal mb-2">Aviso Legal</h1>
          <p className="text-sm text-gray-400 mb-8">Última actualización: 27 de julio de 2026</p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Información legal</h2>
          <p className="text-gray-600 leading-relaxed">
            El presente Aviso Legal regula el uso del portal de recogida a domicilio del <strong>Ayuntamiento de San Fernando de Henares</strong>,
            servicio operado por <strong>Valoriza Servicios Medioambientales S.A.</strong>, con NIF A28760692 y domicilio en
            Calle Condesa de Venadito, 5, 28027 Madrid, en su condición de concesionaria del servicio de limpieza viaria y recogida
            de residuos del municipio. Contacto: <a href="mailto:protecciondatos.vsm@valorizasm.com" className="text-municipal underline">protecciondatos.vsm@valorizasm.com</a>.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Condiciones generales de uso</h2>
          <p className="text-gray-600 leading-relaxed">
            El acceso y uso de este portal implica la aceptación de las condiciones aquí descritas. El servicio permite a los vecinos/as
            de San Fernando de Henares solicitar la recogida gratuita de enseres domésticos y restos de poda. El usuario se compromete
            a facilitar datos veraces y a hacer un uso adecuado del portal, absteniéndose de cualquier actividad contraria a la ley,
            la moral o el orden público.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Responsabilidad</h2>
          <p className="text-gray-600 leading-relaxed">
            El Ayuntamiento y Valoriza pondrán la máxima diligencia para garantizar la disponibilidad y correcto funcionamiento del
            portal, sin que puedan garantizar la ausencia total de interrupciones por causas de mantenimiento o de fuerza mayor.
            La veracidad de los datos facilitados por el usuario en cada solicitud es responsabilidad exclusiva de este.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Propiedad intelectual</h2>
          <p className="text-gray-600 leading-relaxed">
            Los contenidos, marcas, logotipos y elementos gráficos de este portal son titularidad del Ayuntamiento de San Fernando de
            Henares y/o de Valoriza Servicios Medioambientales S.A., quedando prohibida su reproducción sin autorización expresa.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Legislación aplicable</h2>
          <p className="text-gray-600 leading-relaxed">
            Las presentes condiciones se rigen por la legislación española. Cualquier controversia derivada del uso del portal se
            someterá a los juzgados y tribunales competentes conforme a la normativa vigente.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
